/*
 * Fixed position footer
 * ----------------------------------------------- */
jQuery(window).on("load", function () {
  var $btnNav = $(".navbar .nav-scroll .btn-nav-link.btn-link-contact");
  var $btnCta = $(".btn-cta:not(.btn-cta-green");
  var hrefNav = $btnNav.attr("href");
  var hrefCta = $btnCta.attr("href");
  $btnNav.on("click", function (e) {
    e.preventDefault();
    setTimeout(function () {
      window.location.href = hrefNav;
    }, 500);
  });
  $btnCta.on("click", function (e) {
    e.preventDefault();
    setTimeout(function () {
      window.location.href = hrefCta;
    }, 500);
  });
});
